module.exports = __webpack_public_path__ + "img/capa2.8877d07b.webp";